import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import { SupportedLanguage } from '@estercare/ester-shared'

import sv from './locales/sv/translation'
import en from './locales/en/translation'
import nb from './locales/nb/translation'

void i18n.use(initReactI18next).init({
  resources: {
    [SupportedLanguage.SWEDISH]: { translation: sv },
    [SupportedLanguage.ENGLISH]: { translation: en },
    [SupportedLanguage.NORWEGIAN]: { translation: nb },
  },
  lng: SupportedLanguage.SWEDISH,
  fallbackLng: SupportedLanguage.SWEDISH,
  interpolation: { escapeValue: false },
})

export default i18n
